import { activeTipTapExtensions } from '../../utils/tiptap/activeTipTapExtensions.mjs'
import { getTextFromNode } from '../../utils/tiptap/getTextFromHtml.mjs'
import { getNoteContentAsJson } from './getNoteContentAsJson.mjs'

export function getNoteContentAsPlainText(note) {
  if (!note || !note.yDoc) return ''
  return getTextFromNode(
    getNoteContentAsJson(note),
    activeTipTapExtensions.get(),
  )
}
